import React, { useEffect, useState, Fragement } from "react";
import axios from "axios";
import { server } from "../../utills/utils";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
`;
const Header = styled.div`
  width: 100%;
  height: 10%;
  border-bottom: 1px solid #eee;
`;
const Body = styled.div`
  width: 100%;
  height: 74%;
  padding: 3% 0;
  overflow-y: scroll;
`;
const Footer = styled.div`
  width: 100%;
  height: 10%;
  border-top: 1px solid #eee;
`;
const Title = styled.h3`
  width: 80%;
  float: left;
  padding: 0;
  margin: 0;
  text-align: left;
`;
const CloseButton = styled.button`
  float: right;
`;
const ImageContainer = styled.div`
  width: 90%;
  height: 80%;
  margin-left: 5%;
  text-align: center;
`;
const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  border-radius: 5px;
`;
const Images = styled.div`
  width: 100%;
  height: 60px;
  padding: 10px 0;
  text-align: center;
`;
const NotActiveImage = styled.img`
  width: 50px;
  height: 50px;
  border: 2px solid gray;
  cursor: pointer;
  border-radius: 5px;
  margin: 0 4px;
`;
const ActiveImage = styled.img`
  width: 50px;
  height: 50px;
  border: 2px solid green;
  cursor: pointer;
  border-radius: 5px;
  margin: 0 4px;
`;
const PriceContainer = styled.div`
  width: 50%;
  height: 100%;
  float: left;
`;
const AddToCart = styled.button`
  float: right;
  padding: 10px 30px;
  margin: 10px 10px 0 0;
  font-weight: 600;
  font-size: 1em;
  background: #276fb7;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
`;
const Price = styled.p`
  font-weight: 600;
  margin: 10px 0 0 0;
  padding: 0;
`;
const Quantity = styled.p`
  margin: 0;
  padding: 0;
  color: #276fb7;
`;
const Description = styled.p``;
function ProductView(props) {
  const [product, setProduct] = useState({});
  const [complete, setComplete] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  console.log("ProductView", props);
  const fetchProduct = async (id) => {
    if (id) {
      const product = await axios.post(server, {
        query: `
                              query{
                                  shopProduct(id:"${id}"){
                                        _id
                                        name
                                        price
                                        product{
                                        _id
                                        name
                                        brandName
                                        brandId
                                        name
                                        price
                                        measurment
                                        images
                                        description
      
                                        }
                                      }
                                  }
                                `,
      });

      setProduct(product.data.data.shopProduct);
      setComplete(true);
    }
  };

  const closeModal = () => {
    props.closeModal();
    setComplete(false);
  };
  const changeImageHandler = (id) => {
    setActiveImage(id);
  };
  useEffect(() => {
    setActiveImage(0);
    fetchProduct(props.id);
  }, [props.id]);
  let view;
  complete && product
    ? (view = (
        <Container>
          <Header>
            <Title>{product.name}</Title>
            <CloseButton onClick={closeModal}>Close</CloseButton>
          </Header>
          <Body>
            <ImageContainer>
              <Image src={product.product.images[activeImage]} />
            </ImageContainer>
            <Images>
              {product.product.images.map((image, id) => {
                if (activeImage == id) {
                  return (
                    <ActiveImage
                      onClick={() => changeImageHandler(id)}
                      src={image}
                      key={id}
                    />
                  );
                } else {
                  return (
                    <NotActiveImage
                      onClick={() => changeImageHandler(id)}
                      src={image}
                      key={id}
                    />
                  );
                }
              })}
            </Images>
            <p>Description</p>
            <Description>{product.product.description}</Description>
          </Body>
          <Footer>
            <PriceContainer>
              <Price>{product.price} TK</Price>
              <Quantity>{product.product.measurement}1 kg</Quantity>
            </PriceContainer>
            {localStorage.catId != "6129e467f8785a2974c9915a" ? (
              <AddToCart
                onClick={() => props.addToCartHandler(props.productId)}
              >
                Add to basket
              </AddToCart>
            ) : null}
          </Footer>
        </Container>
      ))
    : (view = <p>Loading...</p>);
  return view;
}

export default ProductView;
